<template>
<div>
    <div class="bg_gray"></div>
    <div class="shoppingCart">
                <!-- 顶部 -->
            <van-nav-bar
              title="购物车"
              :right-text="cartStateText"
              :border="false"
              @click-right="onClickRight"
              fixed
              safe-area-inset-top 
               
            />
            <template v-if="goods.length">
            <div v-for="(item,index) in goods" :key="item.id" class="contentBox" >
                  <!-- 复选框 -->
                 <input type="checkbox" class="checkBox" name="checkBoxTest" :checked="item.checked" @click="singleSelect(item,index)" >
                 <!-- 商品照片 -->
                 <div class="commodityImg" @click="singleSelect(item,index)"> <img src="@/assets/images/pic_shop_ popup1@2x.png" alt=""> </div>
                 <div class="commodityInfo">
                  <h2 class="van-ellipsis" >{{item.title}}</h2>
                  <span>{{item.weight}}克+简易包装</span>
                  <div class="countMoney  flex_between">
                      <div class="money">¥{{((+item.pricehj * +item.weight)*item.stepperValue)?((+item.pricehj * +item.weight)*item.stepperValue).toFixed(2):0}}</div>
                      <div class="count">  <van-stepper v-model="item.stepperValue" min="1" max="5" input-width="40px" button-size="26px" disable-input/> </div>
                  </div>
                 </div>
            </div>
            </template>
            <template  v-if="!goods.length">
                <van-empty
                  class="custom-image"
                  :image="require('@/assets/images/pic_no goods@2x.png')"
                  description="空空如也！快去选购你喜欢的商品吧"
                /> 
            </template>
    </div>
    <div class="totalGoods" >
                    <input type="checkbox" class="checkBoxAll" name="checkBoxTestAll" :checked="isAllSelected" @click="allSelect">
                    <span class="selectAllText">全选</span>
                        <div class="total" v-if="cartState">
                           <div class="totalMoney">
                               合计: &nbsp; &nbsp; ¥{{totalMoney?totalMoney.toFixed(2):0.00}}
                           </div>
                           <div class="totalWeight">
                               克重: &nbsp; &nbsp;{{totalWeight.toFixed(2)}}g
                           </div>
                        </div>
                        <div class="jieSuan" v-if="cartState">
                           去结算({{settlement}})
                        </div>
                        <div class="delete" v-if="!cartState" @click="deleteData">删除</div>

    </div>
    <footer class="foot">
             <div class="flex-around">
                <div @click="linkMall">
                    <div class="footerboximg"><img src="@/assets/images/icon_mall-nor@2x.png" alt="" /></div>         
                    <div class="footerText">商城</div>
                 </div>
                  <div @click="linkCart">
                    <div class="footerboximg"><img src="@/assets/images/icon_trolley_sel@2x.png" alt="" /></div>         
                    <div class="footerText">购物车</div>
                 </div>
                  <div @click="linkMy">
                     <div class="footerboximg"><img src="@/assets/images/icon_personal_nor@2x.png" alt="" /></div>
                     <div class="footerText">我的</div>
                 </div>
            </div>
    </footer>
</div>
</template>

<script>
import Stomp from 'stompjs'

export default {

    data() {
        return {
             cartStateText:"管理",
             cartState:true,
            // 数据
             goods: [
                {
                    id: 1,
                    title: 'Au9999 投资黄金金投资黄金金',
                    money:0,
                    //  计步器
                    stepperValue:1,
                    weight:50,
                    checked: false
                }, 
                {
                    id: 2,
                    title: 'Au9999 投资黄金金投资黄金金',
                    money:0,
                    stepperValue:1,
                    weight:40,
                    checked: false
                }, 
                {
                    id: 3,
                    title: 'Au9999 投资黄金金投资黄金金',
                    money:0,
                    stepperValue:1,
                    weight:30,
                    checked: false
                }, 
                {
                    id: 4,
                    title: 'Au9999 投资黄金金投资黄金金',
                    money:0,
                    stepperValue:1,
                    weight:20,
                    checked: false
                }, 
                {
                    id: 5,
                    title: 'Au9999 投资黄金金投资黄金金',
                    money:0,
                    stepperValue:1,
                    weight:10,
                    checked: false
                }, 
                {
                    id: 6,
                    title: 'Au9999 投资黄金金投资黄金金',
                    money:0,
                    stepperValue:1,
                    weight:30,
                    checked: false
                }, 
                {
                    id: 7,
                    title: 'Au9999 投资黄金金投资黄金金',
                    money:0,
                    stepperValue:1,
                    weight:30,
                    checked: false
                }
             ],
             //  合计克重
             totalWeight:0,
             //  合计结算单数
             settlement:0,
             //  合计金额
             totalMoney:0,   
             pricehj:0,
             priceboj:0,
             pricebaj:0,
             pricebaiy:0,
             initPrice:{
                 huangjin:'huangjin9999',
                 baiyin:'baiyin9999',
                 bajin:"bajin9996",
                 bojin:"bojin9996"
             },
             client: {},
             // 所有商品数据
             allpro:[],
             // 首次加载的数据
             initDatalist: [],
             // 是否开盘
             trade_: false,
             // 提交时间
             postTime:'',
        }
    },
    computed:{
          // 是否全选
          isAllSelected:{
            get(){
                if (this.goods.length == 0) {
                    return false
                  
                }else{
                    return this.goods.every((el) => {
                        return el.checked;
                     })
                }

            },
            set(){
                if (this.goods.length == 0) {
                    return false
                  
                }else{
                    return this.goods.map((el) => {
                    return el.checked = false;
                 })
                }
            
            }
          
          },
          // 选中的商品
          checkedGoods(){
              let filterArr = this.goods.filter((el) => {
                  return el.checked;
              });
              return filterArr.map((el) => {
                  return el
              })
          }
    },
    watch:{
        allpro:function(){
             if(this.initPrice != ''){
                 this.updatearr(this.initPrice)
                 if (this.goods.length !=0) {
                    this.goods.forEach((item)=>{
                        this.$set(item,'pricehj',this.pricehj)
                    })
                 }
          
             }
        },
        checkedGoods:{
            handler(newVal,oldVal){

                let weight = 0
                let settlement = 0
                let money = 0
                newVal.forEach((item)=>{
                    weight += item.weight * item.stepperValue
                    settlement += item.stepperValue
                    money += (item.pricehj * item.weight)* item.stepperValue
                })
                this.totalWeight = weight
                this.settlement = settlement
                this.totalMoney = money
              },
              deep:true
        },
        // goods:{
        //     handler(newVal,oldVal){
        //         if (newVal.length == 0) {
        //                 this.isAllSelected = false
        //                 console.log(newVal);
        //         }
        //     },
        //     deep:true
        // }
    },
    methods:{
        // 删除按钮事件
        deleteData(){
            if (this.isAllSelected) {
                this.goods.splice(0,this.goods.length)
            }else{
                for (let i = 0; i < this.goods.length; i++) {
                        if (this.goods[i].checked == true) {
                            this.goods.splice(i,1)
                            i--
                        }                    
                }
                console.log(this.isAllSelected,this.goods);
            }
      
        },
        // 导航栏 右侧按钮事件
        onClickRight(){
            this.cartState = !this.cartState
            this.cartState ? this.cartStateText = "管理" :this.cartStateText = "完成" 
            if (this.cartState) {
                this.isAllSelected = false
            }
          
        },
        linkMall(){
          this.$router.push({name:"shoppingMall"})
        },      
        linkCart(){
          this.$router.push({name:"shoppingCart"})
        },      
        linkMy(){
          this.$router.push({name:"shoppingMy"})
        },
       // 全选、全不选
        allSelect() {
            let checked = true;
            // 全选
            if(this.isAllSelected){
                checked = false;
            }
            this.goods = this.goods.map(el => {
                el.checked = checked;
                return el;
            })
        },
        // 单选
        singleSelect(item, index) {
            
            item.checked = !item.checked;
            this.goods.splice(index, 1, item);
            
        },
        unzip(b64Data) {
            let strData = atob(b64Data);
            const charData = strData.split("").map(function(x) {
              return x.charCodeAt(0);
            });
            const binData = new Uint8Array(charData);
            const data = pako.inflate(binData);
            strData = String.fromCharCode.apply(null, new Uint16Array(data));
            return decodeURIComponent(escape(strData));
        },
        onConnected() {
          const topic = "/price/all";
          this.client.subscribe(topic, this.responseCallback, this.onFailed);
        },
        connect() {
            this.client = Stomp.over(new WebSocket(process.env.VUE_APP_WS));
            // ---初始化mqtt客户端，并连接mqtt服务
            const headers = {
              login: "username",
              passcode: "password"
            };
            this.client.connect(headers, this.onConnected, this.onFailed);
            this.client.debug = null;
        },
        onFailed(frame) {
            console.log("错误: " + frame);
                if (!this.client.connected) {
              setTimeout(() => {
                console.log('11');
                this.connect();
              }, 1000);
            }
        },
        deepMerge(...objs) {
            const than = this
            const result = Object.create(null)
            objs.forEach(obj => {
              if (obj) {
                Object.keys(obj).forEach(key => {
                  const val = obj[key]
                  if (than.isPlainObject(val)) {
                    // 递归
                    if (than.isPlainObject(result[key])) {
                      result[key] = than.deepMerge(result[key], val)
                    } else {
                      result[key] = than.deepMerge(val)
                    }
                  } else {
                      //  数组也要重新赋值  不然依然会引用到其他的
                    if (Array.isArray(val)) {
                      result[key] = [...val]
                    } else {
                      result[key] = val
                    }
                  }
                })
              }
            })
            return result
        },
        isPlainObject(val) {
              const toString = Object.prototype.toString
              return toString.call(val) === '[object Object]'
        },
        responseCallback (frame) {
              this.allpro = []
              const resbody = eval('['+this.unzip(frame.body)+']')[0]
              const parse_res = JSON.parse(JSON.stringify(resbody));
              this.trade_ = resbody.trade;
              this.postTime = resbody.time
              // console.log('postTime1',this.postTime);
              if(this.firstloadData){
                this.initDatalist = resbody
                this.firstloadData = false
                for(const i in this.initDatalist){
                  if(this.initDatalist[i]['prices'] != undefined){

                    this.allpro.push(this.initDatalist[i]['prices'])
                  }
                }
              }else{
                this.initDatalist = this.deepMerge(this.initDatalist,parse_res)
                for(const i in this.initDatalist){
                  if(this.initDatalist[i]['prices'] != undefined){
                    this.allpro.push(this.initDatalist[i]['prices'])
                      }
                   }
                }
        },
        // 价格变动更新视图
        pricenew(obj){
              this.allpro.find((x)=>{
                if(x[obj.huangjin]){
                  this.pricehj = x[obj.huangjin]['xiaoshou']
                }        
                if(x[obj.baiyin]){
                  this.pricebaiy = x[obj.baiyin]['xiaoshou']
                }        
                if(x[obj.bajin]){
                  this.pricebaj = x[obj.bajin]['xiaoshou']
                }        
                if(x[obj.bojin]){
                  this.priceboj = x[obj.bojin]['xiaoshou']
                }
              })
        },
        // 更新数组
        updatearr(obj){
                this.pricenew(obj)
        },
    },
    mounted() {
        this.connect()
    },
}
</script>

<style lang="scss" scoped="true">

::v-deep{
     .van-nav-bar{
        height: 88px;
        .van-nav-bar__content{
        line-height: 88px;
        height: 88px;
        background: #fff;
        .van-nav-bar__title{
            font-size: 36px;
            color: #242424;
        }
        .van-nav-bar__text{
            font-size: 32px;
            font-weight: 500;
            color: #242424;
        }
        .van-icon{
            font-size: 40px;
            color: #212121;
        }
        }
     }
    .van-stepper{
            button{
                background-color: #fff;
            }
            .van-stepper__input{
                font-size: 32px;
            }
            .van-stepper__plus{
                color: #242424;
                font-weight: 600;
            }
     }
    .van-empty__image{
        width: 320px;
        height: 320px;
    }
}
.bg_gray {
    background: #F6F6F6;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
}
.shoppingCart{
    position: relative;
    z-index: 1;
    width: 100;
    padding: 100px 30px 240px;
}
.totalGoods{
    position: relative;
    height: 120px;
    width: 100%;
    position: fixed;
    z-index: 1;
    left: 0;
    bottom: 100px;
    background-color: #fff;
    padding: 20px 32px;
    display: flex;
    justify-content: space-between;
    .selectAllText{
        color: #242424;
        font-size: 24px;
        line-height: 80px;
        margin-left: 40px;
    }
    .total{
        margin-left: -40px;
        .totalMoney{
            font-size: 28px;
            color: #242424;
            font-weight: 800;
        }
        .totalWeight{
            font-size: 24px;
            color: #666666;
            margin-top: 6px;
        }
    }
    .jieSuan{
        width: 288px;
        height: 64px;
        background: linear-gradient(90deg, #F05752 0%, #F07556 100%);
        border-radius: 50px;
        font-size: 28px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 64px;
        text-align: center;
    }
}
.delete{
    width: 288px;
    height: 80px;
    border-radius: 40px 40px 40px 40px;  
    border: 1px solid #FF4F37;
    text-align: center;
    line-height: 80px;
    color: #FF4F37;
}
.foot{
    width: 100%;
    height: 100px;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: #fff;
    z-index: 1;
    border-top: 1px solid #E9E9E9;
    font-size: 22px;
    color: #242424;
    .footerboximg {
    margin: 10px auto 0px;
    width: 48px;
    height: 48px;
    
    }
    .footerText{
        text-align: center;
    }
}
.flex_between{
    display: flex;
    justify-content: space-between;
}
.contentBox{
    width: 100%;
    height: 224px;
    background: #FFFFFF;
    border-radius: 24px;
    margin-top: 24px;
    padding: 40px  24px;
    display: flex;
    .commodityImg{
        width: 144px;
        height: 100%;
        margin: 0 40px 0 20px;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .commodityInfo{
        width: 62%;
        h2{
            color: #242424;
            font-weight: 400;
            font-size: 36px;
        }
        span{
            font-size: 28px;
            color: #999999
        }
        .countMoney{
            margin-top: 16px;
            .money{
                font-weight: 600;
                color: #FF4F37;
                font-size: 36px;
            }
        }
    }
}
.checkBox[type="checkbox"]{
    width:20px;
    height:20px;
    display: inline-block;
    text-align: center;
    vertical-align: middle; 
    line-height: 30px;
    border-radius: 50%;
    position: relative;
    top: 50%;
    margin-top: -10px;
    margin-right: 20px;
    }
.checkBox[type="checkbox"]::before{
    content: "";
    position: absolute;
    top: -6px;
    left: -6px;
    background: #fff;
    width:30px;
    height: 30px;
    border: 1px solid #ccc;
    border-radius: 50%;
    }
.checkBox[type="checkbox"]:checked::before{
    content: "\2713";
    background-color: #ff4f37;
    position: absolute;
    top: -6px;
    left: -6px;
    width:30px;
    height: 30px;
    border: 1px solid #e9e9e9;
    border-radius: 50%;
    color:#fff;
    line-height: 34px;
    font-size: 24px;
    font-weight: bold;
    }

.checkBoxAll[type="checkbox"]{
    width:20px;
    height:20px;
    display: inline-block;
    text-align: center;
    vertical-align: middle; 
    line-height: 30px;
    border-radius: 50%;
    position: absolute;
    top: 40%;
    }
.checkBoxAll[type="checkbox"]::before{
    content: "";
    position: absolute;
    top: -6px;
    left: -6px;
    background: #fff;
    width:30px;
    height: 30px;
    border: 1px solid #ccc;
    border-radius: 50%;
    }
.checkBoxAll[type="checkbox"]:checked::before{
    content: "\2713";
    background-color: #ff4f37;
    position: absolute;
    top: -6px;
    left: -6px;
    width:32px;
    height: 32px;
    border: 1px solid #e9e9e9;
    border-radius: 50%;
    color:#fff;
    line-height: 34px;
    font-size: 28px;
    color: #fff;
    font-weight: bold;
    }
</style>